export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Информационная безопасность: Внешнее API - пользователи",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
